import {POCKETS} from "./tableGeometry";

// The table's physics is built from the shared outlines by physics/table.ts (the cushion line, shared/rules.ts
// CUSHION_LINE, and the pocket polygons, tableGeometry.ts); the 3D table by TableModel.ts from the same outlines.
let Table = {
    Init: function (){
        // nothing to build here any more: World.Init creates the simulation with the walls and pockets
    },
    // A ball whose centre enters one of these is potted (physics/solver.ts). Same polygons as before: tableGeometry.ts.
    Pockets: POCKETS
};

export default Table;
